import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { PLBSClassNames } from "../../models/PLBSClassNames/plbs-class-names";
import { IPLBSClassNamesRepository } from "./IPLBSClassNamesRepository";

@Injectable()
export class PLBSClassNamesRepository extends GenericRepository<PLBSClassNames> implements IPLBSClassNamesRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/plbsclassnames', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this._http
            .get(this.url + 'api/plbsclassnames/SelectAll' + '/' + currentPage + '/' + recordsPerPage, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(code: string): Observable<any> {
        return this._http
            .delete(this.url + 'api/plbsclassnames/DeleteRec' + '/' + code, this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    GetAllPLBSClassNames(code: string = ""): Observable<any> {
        return this._http
            .get(this.url + 'api/plbsclassnames/GetRec' + '/' + code, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
}
